import Image from "next/image";
import { ReactNode } from "react";
import s from "./styles.module.sass";
import errorSrc from "../../../../public/icons/error.svg";
import clsx from "clsx";

type NotificationProps = {
	type: "error";
	title: string;
	text?: string;
	children?: ReactNode;
};

const Notification = ({ type = "error", title, text, children }: NotificationProps) => {
	const wrapperClasses = clsx(s.notificationWrapper, {
		[s.alignCenter]: text === undefined,
	});
	return (
		<div className={wrapperClasses}>
			<div className={s.iconWrapper}>
				<Image src={errorSrc} layout="fill" objectFit="contain" alt={type} />
			</div>
			<div className={s.info}>
				<p>
					<b>{title}</b> {text}
				</p>
				{children}
			</div>
		</div>
	);
};

export default Notification;
